import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Box, Button, Menu, MenuItem } from "@mui/material";
import { useState } from "react";

export default function SelectVMP({data, selectedValue, index, styleSelectElement, styleIconElement, setSelectedValue, role}){
    // const [_data, _setData] = useState(data)
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (value) => {
        setAnchorEl(null);
        setSelectedValue(value);
    };

    const handleClosePopUp = () => {
        setAnchorEl(null);
    }

    return (
        <Box className={`box-select-${index}`} sx={{position: 'relative'}}>
            {/* <Box sx={{display: 'flex', alignItems: 'center', cursor: 'pointer', ...styleSelectElement}} onClick={() => setOpenPopup(!openPopup)}>
                <Box>
                        {(_data?.find(el => el?.value == selectedValue)?.name)}
                </Box>
                {openPopup ? <KeyboardArrowUpIcon sx={styleIconElement} fontSize="small"/> : <KeyboardArrowDownIcon sx={styleIconElement} fontSize="small"/>}
            </Box>

           {openPopup &&  
           <Box sx={{position: 'absolute', display: 'flex', flexDirection: 'column', boxShadow:'rgb(0 0 0 / 20%) 0px 5px 5px -3px, rgb(0 0 0 / 14%) 0px 8px 10px 1px, rgb(0 0 0 / 12%) 0px 3px 14px 2px', padding: '5px 10px', zIndex: '1000', backgroundColor: '#fff'}}>
                {
                    _data?.map(item => {
                        return (
                            <Box sx={{cursor: 'pointer'}}  value={item?.value} onClick={() => handleSelectItem(item)}>{item?.name}</Box>
                        )
                    })
                }
            </Box>} */}
            <Button
                id="basic-button"
                sx={{backgroundColor: '#fff', padding: '0', fontSize: '12px'}}
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                variant="text"
                size="small"
                endIcon={<ArrowDropDownIcon />}
            >
                {
                    role === "host"
                    ?
                    "Chủ trì"
                    : 
                    "Đồng chủ trì"
                }
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClosePopUp}
                MenuListProps={{
                'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem key={'host'} onClick={() => handleClose("host")}>Chủ trì</MenuItem>
                <MenuItem key={'coHost'} onClick={() => handleClose("coHost")}>Đồng chủ trì</MenuItem>
            </Menu>
        </Box>
    )
}